import React from 'react';
import { Grid } from '@mui/material';
import { MenuItem, SelectField, Icons, Stack } from "@curves/ui-base";
import {
	rowLabelCheckboxSheet,
	SpecialConditionBox,
	getMemberSheet,
	getMemberFilterCellPhoneSheet,
	contactSheet,
	moreSheet,
} from '@icoach/components/';
import { refIsRequiredError, findIndexFn } from '@util/utils';
import { displayDateText } from '@util/moment';

export const FilterHighRiskSearch = React.forwardRef((props, ref) => {
	const { resource = {}, paramsData = {} } = props;
	const { highRiskWorkoutGradeOption = [] } = resource;
	const workoutGradeRef = React.useRef(null);

	React.useImperativeHandle(ref, () => {
		return {
			isError: () => refIsRequiredError(workoutGradeRef),
			getResult: () => {
				let result = {};
				if (workoutGradeRef.current && workoutGradeRef.current.getResult) {
					result = Object.assign(result, {
						workoutGradeFilter: workoutGradeRef.current.getResult(),
					});
				}
				return result;
			},
		};
	});

	const workoutGrade =
		findIndexFn(highRiskWorkoutGradeOption, 'value', paramsData.workoutGradeFilter) !== -1
			? paramsData.workoutGradeFilter
			: highRiskWorkoutGradeOption[0]?.value ?? '';

	return (
		<React.Fragment>
			<Grid item xs={2}>
				<SelectField label={'會員運動等級'} defaultValue={workoutGrade} ref={workoutGradeRef} fullWidth>
					{Array.isArray(highRiskWorkoutGradeOption) &&
						highRiskWorkoutGradeOption
							.filter((item) => item && !item.disabled)
							.map((item) => (
								<MenuItem key={item.value} value={item.value}>
									{item.text}
								</MenuItem>
							))}
				</SelectField>
			</Grid>
		</React.Fragment>
	);
});

//********************** 高風險名單(續約CDE名單) **********************//
export const getFilterHighRiskLabel = (isRevealed, isShowContactGroup) => {
	return [
		{ ...rowLabelCheckboxSheet },
		{ ...getMemberSheet({ isRevealed }), isFixed: true, isFixedLeft: true },
		{ ...getMemberFilterCellPhoneSheet({ isRevealed, isShowContactGroup }) },
		{
			cellKey: 'specialCondition',
			headerLabel: '聯繫注意與偏好',
			width: 18,
			formatCell: (specialCondition, { memberID }, { setSourceDataById }) => {
				return <SpecialConditionBox sourceData={{ memberID, value: specialCondition }} setSourceDataById={setSourceDataById} />;
			},
		},
		{
			cellKey: 'contractEndDate',
			headerLabel: '現行合約終止日',
			width: 17,
			align: 'center',
			formatCell: (value) => displayDateText(value),
		},
		{
			cellKey: 'membershipDuration',
			headerLabel: '會籍已持續時間',
			width: 17,
			align: 'center',
			formatCell: (value) => `${value} 個月`,
		},
		{
			cellKey: 'exerciseLevel',
			headerLabel: '運動等級',
			width: 14,
			align: 'center',
		},
		{
			cellKey: 'recentMeasureRecord',
			headerLabel: '量身頻率',
			align: 'center',
            width: 24,
			formatCell: (value) => {
				const mAry = Array.isArray(value) ? value : [];
				return (
					<Stack justifyContent="center">
						{mAry.map((checked, index) => (checked ? <Icons.Check key={index} color="success" /> : <Icons.Close key={index} color="error" />))}
					</Stack>
				);
			},
		},
		{ ...contactSheet },
		{ ...moreSheet },
	];
};
